module.exports = __webpack_public_path__ + "static/img/TOM-LUCK.42d5282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TOM-LUCK.jpg
// module id = BpNE
// module chunks = 0